/* eslint-disable no-undef */
import 'dayjs/locale/id'
import * as dayjs from 'dayjs'
var utc = require('dayjs/plugin/utc')
dayjs.extend(utc)
var relativeTime = require('dayjs/plugin/relativeTime')
dayjs.extend(relativeTime)
dayjs.locale('id')

// Date & Time

// convert local time to UTC time
export const dateTimeWithUTCLocal = (date) => {
  if (date) return dayjs(date).utc().format('dddd, DD MMM YYYY, HH:mm')
  return null
}
export const dateTimeConvertToUTC = (date) => {
  if (date) return dayjs.utc(date).local().format('dddd, DD MMM YYYY, HH:mm')
  return null
}

export const dateRelativeTime = (date) => {
  if (date) return dayjs(date).fromNow()
  return null
}

export const dateTimeForFile = (date) => {
  if (date) return dayjs(date).format('MM_YYYY')
  return null
}

export const dateFullWithTime = (date) => {
  if (date) return dayjs(date).format('DD/MM/YYYY, HH:mm')
  return null
}

export const dateFullWithTimeSeconds = (date) => {
  if (date) return dayjs(date).format('DD/MM/YYYY HH:mm:ss')
  return null
}

export const dateShortMonthWithTime = (date) => {
  if (date) return dayjs(date).format('DD MMM YYYY HH:mm')
  return null
}

export const dateTimeFullDayWithTime = (date) => {
  if (date) return dayjs(date).format('dddd, DD MMM YYYY, HH:mm')
  return null
}

export const dateTimeFullMonthWithSeconds = (date) => {
  if (date) return dayjs(date).format('DD MMMM YYYY – HH:mm:ss [WIB]')
  return null
}

export const dateStringSimply = (date) => {
  if (date) return dayjs(date).format('DD/MM/YYYY')
  return null
}

export const dateTimeFullMonth = (date) => {
  if (date) return dayjs(date).format('MMMM YYYY')
  return null
}

export const dateString = (date) => {
  if (date) return dayjs(date).format('YYYY-MM-DD')
  return null
}

export const dateWithStripFullYear = (date) => {
  if (date) return dayjs(date).format('DD-MM-YYYY')
  return null
}

export const dateTimeFullDay = (date) => {
  if (date) return dayjs(date).format('DD, MMMM YYYY HH:mm')
  return null
}

export const dateFullMonth = (date) => {
  if (date) return dayjs(date).format('DD MMMM YYYY')
  return null
}

export const dateYearOnly = (date) => {
  if (date) return dayjs(date).format('YYYY')
  return null
}

export const dateHeaderString = (date) => {
  if (date) return dayjs(date).format('dddd, DD MMMM YYYY')
  return null
}

export const dateStartTimeString = (date) => {
  if (date) return dayjs(date).format('YYYY-MM-DD 00:00:00')
  return null
}

export const dateEndTimeString = (date) => {
  if (date) return dayjs(date).format('YYYY-MM-DD 23:59:59')
  return null
}

export const hoursString = (date) => {
  if (date) return dayjs(date).format('HH:mm')
  return null
}

export const dateUnixString = () => {
  return dayjs().unix().toString()
}

export const dateAddDays = (date, day) => {
  if (date) return dayjs(date).add(day, 'day')
  return null
}

export const dateDiffDays = (nextDate, prevDate) => {
  if (nextDate) return dayjs(nextDate).diff(prevDate, 'day')
  return null
}
export const roundedDecimals = (number) => {
  if (number) return number.toFixed(2)
  return number
}

export const roundedDecimalsSwapComma = (number) => {
  if (number) return number.toFixed(2).replace(".", ",")
  return number
}

export const thousandSeparator = (number) => {
  if (number>999 || number<-999){
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
  } else {
    return number
  }
}

export const thousandSeparatorFloat = (number, limit) => {
  if (number == undefined || number == null) {
    return '-'
  } else {
    if(limit == 1){
      return thousandSeparator(number.toFixed(limit).replace(".",",").replace(",0"," "))
    } else {
      return thousandSeparator(number.toFixed(limit).replace(".",","))
    }
  }
}

export const currencyRupiah = (value) => {
  const num = Math.round(Number(value))
  if (!Number.isFinite(num)) return 'Rp 0'
  const digits = Math.abs(num).toString()
  const formatted = digits.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  return num < 0 ? `Rp -${formatted}` : `Rp ${formatted}`
}

export const currencyDigit = (value) => {
  if (value === null || value === undefined || value === '') return ''
  let num
  if (typeof value === 'number') {
    // Number input (raw dari API/JSON) bisa punya decimal cents — round.
    num = Math.round(value)
  } else {
    // String input (dari user input field atau formatted display) — selalu treat
    // dot sebagai thousands separator. Strip semua non-digit.
    const str = String(value).trim()
    const negative = str.startsWith('-')
    const digits = str.replace(/\D/g, '')
    if (!digits) return ''
    num = parseInt(digits, 10)
    if (negative) num = -num
  }
  if (!Number.isFinite(num)) return ''
  if (num === 0) return '0'

  const digits = Math.abs(num).toString()
  const formatted = digits.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  return num < 0 ? `-${formatted}` : formatted

  // if (value) return `${value?.toString()?.replace(/\D/g, "")?.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`
}

export const summaryOneTarget = (dataArray, target) => {
  if (dataArray) return dataArray.reduce((a, b) => a + b[target], 0)
  return null
}

export const getBase64 = (img, callback) => {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}
